import isUrl from 'is-url-superb';
import { z } from 'zod';

export const ReportNewFormValuesSchema = z.object({
    period: z.object({
        start: z.date({ coerce: true }),
        end: z.date({ coerce: true }),
    }),
});
